import React, { useEffect, useState } from 'react';
import ConfirmModal from '../../components/ConfirmModal';
import OpenGuests from './components/OpenGuests';
import PaidGuests from './components/PaidGuests';
import ExportModal from './components/ExportModal';
import BookingModal from '../../components/BookingModal';
import axios from 'axios';
import { API_BASE_URL } from '../../App.js';

const Guests = () => {
    const [searchTerm, setSearchTerm] = useState("");
    const [expandedGuest, setExpandedGuest] = useState(null);
    const [openGuests, setOpenGuests] = useState([]);
    const [paidGuests, setPaidGuests] = useState([]);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [exportModalOpen, setExportModalOpen] = useState(false);
    const [selectedGuest, setSelectedGuest] = useState(null);

    // Modal Context Data
    const [players, setPlayers] = useState([]);
    const [events, setEvents] = useState([]);
    const [profile, setProfile] = useState(null);
    const [showBookingModal, setShowBookingModal] = useState(false);
    const [selectedBooking, setSelectedBooking] = useState(null);

    const fetchOpenGuests = async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/api/openGuests`);
            setOpenGuests(response.data);
        } catch (error) {
            console.error("Error fetching open guest data:", error);
        }
    };

    const fetchPaidGuests = async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/api/paidGuests`);
            setPaidGuests(response.data);
        } catch (error) {
            console.error("Error fetching paid guest data:", error);
        }
    };

    const fetchContextData = async () => {
        try {
            const [playersRes, eventsRes, profileRes] = await Promise.all([
                axios.get(`${API_BASE_URL}/api/activePlayers`),
                axios.get(`${API_BASE_URL}/api/events`),
                axios.get(`${API_BASE_URL}/api/profile`)
            ]);
            setPlayers(playersRes.data);
            setEvents(eventsRes.data);
            setProfile(profileRes.data);
        } catch (error) {
            console.error("Error fetching context data:", error);
        }
    };

    useEffect(() => {
        fetchOpenGuests();
        fetchPaidGuests();
        fetchContextData();
    }, []);


    const toggleGames = (guestName) => {
        setExpandedGuest(expandedGuest === guestName ? null : guestName);
    };

    const handlePaymentClick = (guest) => {
        setSelectedGuest(guest);
        setDialogOpen(true);
    };

    const handleGameClick = async (bookingId) => {
        try {
            const response = await axios.get(`${API_BASE_URL}/api/bookings/${bookingId}`);
            setSelectedBooking(response.data);
            setShowBookingModal(true);
        } catch (error) {
            console.error("Error fetching booking details:", error);
        }
    };

    const handlePaymentConfirm = async () => {
        if (!selectedGuest) return;
        try {
            const gameIds = selectedGuest.games.map(game => game.id);
            const payDate = new Date().toISOString(); 

            // API Call zum Bestätigen der Zahlung
            await axios.post(`${API_BASE_URL}/api/bookingspaid`, { gameIds, payDate });

            // Nach der Zahlung beide Listen neu laden um Konsistenz zu garantieren
            fetchOpenGuests();
            fetchPaidGuests();
            
            setDialogOpen(false);
            setSelectedGuest(null);
            
        } catch (error) {
            console.error("Error processing payment:", error);
        }
    };

    const handleDialogClose = () => setDialogOpen(false);

    const filteredPaidGuests = paidGuests.filter(guest =>
        guest.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div className='row mx-0'>
            <ConfirmModal
                open={dialogOpen}
                onClose={handleDialogClose}
                onConfirm={handlePaymentConfirm}
                title="Bezahlung bestätigen"
                message={
                    <>
                        Möchten Du die Gaststunden-Abbuchung für <strong>{selectedGuest?.name}</strong> bestätigen?
                        <br /><br />
                        <strong>Betrag:</strong> <span style={{ color: '#2e7d32', fontWeight: 'bold' }}>{selectedGuest?.amount} €</span>
                    </>
                }
                confirmText="Bestätigen"
                type="question"
            />
            
            <ExportModal 
                open={exportModalOpen}
                onClose={() => setExportModalOpen(false)}
            />

            {showBookingModal && (
                <BookingModal 
                    show={showBookingModal}
                    onHide={() => setShowBookingModal(false)}
                    free={false}
                    slot={selectedBooking?.startTime}
                    court={selectedBooking?.courtId}
                    data={selectedBooking}
                    players={players}
                    events={events}
                    profile={profile}
                />
            )}

            <div className='col-md-5 ps-0 pe-md-3 pe-0 mb-3'>
                <OpenGuests
                    guests={openGuests}
                    onToggleGames={toggleGames}
                    expandedGuest={expandedGuest}
                    onPaymentClick={handlePaymentClick}
                    onGameClick={handleGameClick}
                />
            </div>
            <div className='col-md ps-0 pe-0 mb-3'>
                <PaidGuests
                    guests={filteredPaidGuests}
                    searchTerm={searchTerm}
                    onSearchChange={(e) => setSearchTerm(e.target.value)}
                    onToggleGames={toggleGames}
                    expandedGuest={expandedGuest}
                    onExportClick={() => setExportModalOpen(true)}
                    onGameClick={handleGameClick}
                />
            </div>
        </div>
    );
};

export default Guests;
